module.exports = __webpack_public_path__ + "img/03.ea149d2b.png";